import React, { useEffect } from 'react';
import { Box, Button, Flex, Text , Alert,AlertIcon, AlertTitle } from '@chakra-ui/react';
import { PiExport } from "react-icons/pi";
import SortBy from '../components/SortBy';
import {fetchMemberPayHistory,  setMemberPayHistoryReportPagination, setMemberPayHistoryReportPageSize} from "../redux/slices/report2Slice";
import { useDispatch, useSelector } from 'react-redux';
import CustomTablePage2 from '../components/CustomTablePage2';

const MemberModuleReport = () => {
    const dispatch = useDispatch();
    const payHistory = useSelector((state) => state?.report2);

    useEffect(() => {
        dispatch(fetchMemberPayHistory());
    }, [ dispatch, payHistory?.reportsParams ]);

    const handlePagination = (page) => {
        dispatch(setMemberPayHistoryReportPagination(page));
    };

    const handlePageSize = (size) => {
        dispatch(setMemberPayHistoryReportPageSize(size));
    };

    const tableProps = {
        data: payHistory?.memberPayHistory?.data,
        title: {
            paymentREFNO: "Payment REF NO.",
            paymentDate:"Payment Date",
            transactionAmount: "Transaction Amount",
            purpose: "Purpose",
            status:"Status",
        },
        dataKeys: [
          "paymentREFNO",
          "paymentDate",
          "transactionAmount",
          "purpose",
          "status",
        ],
        isloading: payHistory?.loading,
        handlePagination,
        handlePageSize,
        itemsPerPage: payHistory?.memberPayHistory?.currentPageRecord,
        totalRecord: payHistory?.memberPayHistory?.totalRecord,
        pageNumber: payHistory?.reportsParams?.page,
        nextPage: payHistory?.memberPayHistory?.nextPage,
        previousPage: payHistory?.memberPayHistory?.previousPage,
        pageSize: payHistory?.reportsParams?.pageSize,
        
        transformRow: (item) => ({
            paymentREFNO: item &&  <Box style={{cursor:'pointer'}}>{item?.paymentReference}</Box>,
            paymentDate: item && <Box style={{cursor:'pointer'}} >{item?.paymentDate}</Box>,
            transactionAmount: item && <Box style={{cursor:'pointer'}} >{item?.transactionAmount}</Box>,
            purpose: item && <Box style={{cursor:'pointer'}} >{item?.purpose}</Box>,    
            status: item &&  <Box style={{cursor:'pointer'}} >{item?.status}</Box>,
        }),
      };

  return (
    <Box bg={'#FFFFFF'} py={'30px'} minH={'100vh'} px={3}>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={'20px'} mb={2}>
            <Text fontSize={'18px'} fontWeight={'700'} color={'#D11A2A'}>PAYMENT HISTORY</Text>
            <Flex flexDirection={["column", "column", "row"]} alignItems={'center'} gap={[3, null, null]}>
                <SortBy />
                <Button leftIcon={<PiExport style={{width: "15px", height: "15px"}} />} bg={'transparent'} _hover={{backgroundColor:"transparent"}} _active={{backgroundColor:"transparent"}} color={'#404040'}
                fontFamily={'inter'} fontSize={'12px'} fontWeight={'500'} lineHeight={'24px'} letterSpacing={'0.4px'} 
                >
                Export
                </Button>
            </Flex>
        </Flex>
        {
            payHistory?.error? (
            <Alert status="error" className="mt-3" mb={3}>
                <AlertIcon />
                <AlertTitle>{payHistory?.error}</AlertTitle>
            </Alert>
            ) : (
            <CustomTablePage2 {...tableProps} />
            )
        }
    </Box>
  )
}

export default MemberModuleReport;